/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VacancyKpiReportControllerGetVacanciesReport200ResponseDataVacanciesSummaryVacanciesInner } from './vacancyKpiReportControllerGetVacanciesReport200ResponseDataVacanciesSummaryVacanciesInner';


export interface VacancyKpiReportControllerGetVacanciesReport200ResponseDataVacanciesSummary { 
    vacancies?: Array<VacancyKpiReportControllerGetVacanciesReport200ResponseDataVacanciesSummaryVacanciesInner>;
    averageSalaryExecutive?: number;
    averageSalaryGeneral?: number;
}

